import { store } from '@/app/store';
import { setBlockedMeUsersList, setBlockedUsersList } from '@/features/users';
import { SDK } from '@/infrastructure/sdk';
import { getUserIdFromJid, logger } from '@/shared/utils';

export const syncBlockedUsers = async () => {
   try {
      const usersIBlocked = await SDK.getUsersIBlocked();
      const usersWhoBlockedMe = await SDK.getUsersWhoBlockedMe();

      if (usersIBlocked.statusCode === 200 && Array.isArray(usersIBlocked.data)) {
         const blockedIds = usersIBlocked.data.map(item => getUserIdFromJid(item.jid));
         store.dispatch(setBlockedUsersList(blockedIds));
      }

      if (usersWhoBlockedMe.statusCode === 200 && Array.isArray(usersWhoBlockedMe.data)) {
         const blockedMeIds = usersWhoBlockedMe.data.map(item => getUserIdFromJid(item.jid));
         store.dispatch(setBlockedMeUsersList(blockedMeIds));
      }

      return { usersIBlocked, usersWhoBlockedMe };
   } catch (error) {
      logger.error('Error syncing blocked users:', error);
      return { usersIBlocked: [], usersWhoBlockedMe: [] };
   }
};
